export const LOAD_SHOP_COUNT_STATS = 'LOAD_SHOP_COUNT_STATS'
export const LOAD_SHOP_DATA_STATS = 'LOAD_SHOP_DATA_STATS'
export const LOAD_SHOP_CATEGORY_STATS = 'LOAD_SHOP_CATEGORY_STATS'
export const LOAD_SHOP_CUSTOMER_STATS = 'LOAD_SHOP_CUSTOMER_STATS'
export const LOAD_SHOP_ADVANCED_COUNT_STATS = 'LOAD_SHOP_ADVANCED_COUNT_STATS'
export const LOAD_SHOP_SALE_STATS = 'LOAD_SHOP_SALE_STATS'
export const LOAD_SHOP_BEST_DAY_STATS = 'LOAD_SHOP_BEST_DAY_STATS'
export const SET_LOADING = 'SET_LOADING'
